<!-- 
  添加&编辑分组
 -->

<template>
  <div class="group-list">
    <el-dialog :title="title" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" class="custom-form">
        <el-form-item label="分组名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="筛选条件" prop="data">
          <condition v-for="(item, index) in form.data" :item="item" :key="item.index" :conditions="condition">
            <template slot="button"     slot-scope="props">
              <el-button @click="addItem" v-if="index === 0" icon="el-icon-plus"></el-button>
              <el-button @click="delItem(index)" v-if="index !== 0" icon="el-icon-minus"></el-button>
            </template>
          </condition>
        </el-form-item>  
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
import { mapGetters } from 'vuex'
import * as common from 'src/config/common-config'
import condition from './edit_group/condition'

export default {
  created () {
    this.getGroupCondition()
  },
  props: ['id', 'formData', 'templateId'],
  data () {
    return {
      dialogVisible: false,
      condition: [],
      form: this.formData,
      rules: {
        name: { required: true, message: '输入分类名称', trigger: 'blur' },
        data: { type: 'array', required: true, message: '请输入筛选条件', trigger: 'change' }
      },
      moduleApi: common.moduleApi
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ]),
    title () {
      if (this.id) {
        return '编辑分组'
      } else {
        return '新建分组'
      }
    }
  },
  methods: {
    // 获取分组列表
    getGroupCondition () {
      let url = `/listGroupApi/conditionAjax.html`
      let params = {
        refType: this.moduleApi[this.moduleName],
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        this.condition = data.result
        // 获取到分组数据后，再开始渲染当前页面
        this.dialogVisible = true
      })
    },
    // 添加筛选条件
    addItem () {
      this.form.data.push({
        index: '',
        name: '',
        symbol: '',
        data: ''
      })
    },
    // 删除筛选条件
    delItem (index) {
      this.form.data.splice(index, 1)
    },
    // 提交
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sendData()
        } else {
          Message({
            type: 'error',
            message: '输入有误，请检查后重新提交！'
          })
          return false
        }
      })
    },
    // 发送数据
    sendData () {
      // 数据格式化
      let data = JSON.parse(JSON.stringify(this.form.data))

      const url = `/listGroupApi/save.html`
      let params = {
        refType: this.moduleApi[this.moduleName],
        name: this.form.name,
        data: data,
        templateId: this.templateId
      }
      // 编辑
      if (this.id) {
        params.id = this.id
      }
      api.post(url, params, (data) => {
        const that = this
        Message({
          type: 'success',
          message: '保存成功！',
          duration: 1000,
          onClose: function () {
            that.dialogVisible = false
            that.$emit('refresh')
          }
        })
      })
    }
  },
  components: {
    condition
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('closeDialog')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .group-list {
    .el-dialog--small {
      width: 740px;
    }
  }
</style>


// WEBPACK FOOTER //
// edit-group.vue?ea5729d2